// extracted by mini-css-extract-plugin
export default {"mainDiv":"UpcommingAppoinment_mainDiv__Fr2J6"};